/* eslint-disable no-shadow */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

const withStructureOptionsHandlers = (Component) => {
  function StructureOptionsDialogHOC(props) {
    const {
      id,
      groupId,
      optionId,
      showMore,
      updateInputValue,
      updateStructureOptionsDialog,
      toggleCheckboxOption,
      toggleRadioOption,
      toggleSubRadioOption,
      updateSavedInfoWithCurrent,
      selfClose,
    } = props;

    const onChangeInput = useCallback(
      (id, groupId, optionId, value) => {
        updateInputValue(id, groupId, optionId, value);
      },
      [updateInputValue]
    );

    const toggleMore = () => {
      updateStructureOptionsDialog({
        id,
        showMore: !showMore,
      });
    };
    const onCheckboxClick = (id, groupId, optionId) => {
      toggleCheckboxOption(id, groupId, optionId);
    };

    const onRadioClick = useCallback(
      (id, groupId, optionId) => {
        toggleRadioOption(id, groupId, optionId);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [id, groupId, optionId]
    );

    const onSubRadioClick = (id, groupId, optionId, subOptionId) => {
      toggleSubRadioOption(id, groupId, optionId, subOptionId);
    };

    const onApplyClick = useCallback(() => {
      updateSavedInfoWithCurrent(id);
      selfClose();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    return (
      <Component
        {...props}
        onChangeInput={onChangeInput}
        toggleMore={toggleMore}
        onCheckboxClick={onCheckboxClick}
        onRadioClick={onRadioClick}
        onSubRadioClick={onSubRadioClick}
        onApplyClick={onApplyClick}
      />
    );
  }

  StructureOptionsDialogHOC.propTypes = {
    id: PropTypes.string,
    showMore: PropTypes.bool,
    groupId: PropTypes.string,
    optionId: PropTypes.string,
    updateInputValue: PropTypes.func,
    updateStructureOptionsDialog: PropTypes.func,
    toggleCheckboxOption: PropTypes.func,
    toggleRadioOption: PropTypes.func,
    toggleSubRadioOption: PropTypes.func,
    updateSavedInfoWithCurrent: PropTypes.func,
    selfClose: PropTypes.func,
  };

  return StructureOptionsDialogHOC;
};

export default withStructureOptionsHandlers;
